import React, { useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Ribbon } from "@/components/Ribbon";
import { FeaturedCollection } from "@/components/FeaturedCollection";
import { About } from "@/components/About";
import { Lookbook } from "@/components/Lookbook";
import { Newsletter } from "@/components/Newsletter";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { getT } from "@/lib/i18n";

function App() {
  const [lang, setLang] = useState("en");
  const t = getT(lang);

  return (
    <div className="app-shell" data-testid="app-root">
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#1C1A18",
            border: "1px solid #3A342E",
            color: "#F3EFE9",
            fontFamily: "Manrope, sans-serif",
            borderRadius: 0,
          },
        }}
      />
      <Header lang={lang} setLang={setLang} t={t} />
      <main>
        <Hero t={t} />
        <Ribbon text={t.marquee} />
        <FeaturedCollection t={t} />
        <About t={t} />
        <Lookbook t={t} />
        <Newsletter t={t} lang={lang} />
        <Contact t={t} lang={lang} />
      </main>
      <Footer t={t} />
    </div>
  );
}

export default App;
